import React, { useState, useEffect, useMemo } from 'react';
import { send_component_save_request, send_request } from '../../utils/Request';
import { injectMetadataFields } from '../../utils/buildComponentSavePayload';
import AddIcon from '@mui/icons-material/Add';
import { getCurrentTime } from '../../utils/getCurrentTime';
import useCalculatorStore, { getCalculatorStore } from './useCalculatorStore';
import styles from './CalculatorComponents/CalculatorStyle';
import ItemCalculation from './CalculatorComponents/ItemCalculation';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import { Grid } from '@mui/material';
import { IndividualComponentLoader } from '../../utils/ComponentLoadingSkeleton';

const CalculatorTemplate = (props) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const store = useMemo(() => getCalculatorStore(props.component_id), [props.component_id]);
  const componentName = useProjectStore(s => s.componentName);

  useEffect(() => {
    if (props.component_id !== undefined) {
      // If store was prefilled from canvas load, skip the REST fetch
      if (store.getState().loaded) {
        props.onComponentNameChanged(store.getState().name);
        props.onLastModifiedChanged(store.getState().lastModified);
        setLoading(false);
        props.setChildTemplateLoaded(true);
        return;
      }

      setLoading(true);
      send_request(
        `project-service/project/component/query/${props.component_id}/at-version/${props.version}`,
        '',
        {}
      )
        .then(response => {
          if (response && response.data) {
            const { components } = response.data;
            if (components) {
              store.getState().setCalculatorData(components[0]);
              store.setState({ loaded: true });
              props.onComponentNameChanged(store.getState().name);
              props.onComponentDescriptionChanged(components[0].description);
              props.onLastModifiedChanged(store.getState().lastModified);
              setLoading(false);
            }
          }

          props.setChildTemplateLoaded(true);
          setLoading(false);
        })
        .catch(err => {
          throw Error(err.message);
        });
    }
  }, []);

  useEffect(() => {
    store.getState().setCalculatorName(componentName);
  }, [componentName]);

  useEffect(() => {
    const unsub = useProjectStore.subscribe(
      s => s.selectedPlaceholder,
      (placeholder) => {
        const activeId = useProjectStore.getState().activeComponentId;
        if (activeId !== null && activeId !== props.component_id) return;
        if (!placeholder['selected']) return;
        const { style, key, isNotPlaceholder } = placeholder['selected'];

        insertPlaceholder(style.default, key, style, isNotPlaceholder);
        addPlaceholder(style.default, key, style);
      }
    );
    return unsub;
  }, []);

  const addPlaceholder = (label, text, style) => {
    const { placeholders, setPlaceholders } = store.getState();
    setPlaceholders([...placeholders, { label, text, style }]);
  };

  const insertPlaceholder = (label, text, style, isNotPlaceholder) => {
    const template = store.getState().getTemplate();
    const index = template.position;
    let { operator, perform } = template.data[index];

    if (isNotPlaceholder !== true) {
      text = '${' + text + '}';
    }

    if (perform === 'FUNCTION') {
      store.getState().setCalculation(text, index, 'operator');
    } else if (perform === 'DATETIME') {
      store.getState().setCalculation(text, index, store.getState().fieldFocus);
    }
  };

  const handleKeyChanges = (err) => {
    setError(err);
  };

  const data = store(s => s.data);

  if (!loading) {
    return (
      <Grid container xs={12} direction={'column'}>
        {data.map((calculation, index) => (
          <ItemCalculation
            key={calculation.keyRandom}
            calculation={calculation}
            indexCalculation={index}
            availablePlaceholders={props.availablePlaceholders}
            handleKeyChanges={handleKeyChanges}
            onPlaceholderSelected={props.onPlaceholderSelected}
            isExpanded={props.isExpanded}
            componentStore={store}
          />
        ))}
        <div style={{ display: 'flex', justifyContent: 'center', margin: '32px 0' }}>
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={() => store.getState().addCalculation()}
          >
            <AddIcon /> Add Calculation
          </div>
        </div>
      </Grid>
    );
  } else return <IndividualComponentLoader />;
};

export default CalculatorTemplate;
